module.exports = __webpack_public_path__ + "img/close.121752d1.svg";